import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
export const Title = styled.span`
  font-size: 18px;
  font-weight: 700;

  transition: 200ms;
  margin-left: 5px;
`;
